import { ToastProvider } from '@pelckmans/elementis/components/toast';
import { BreakpointsContextProvider } from '@pelckmans/elementis/contexts/BreakpointsContext';
import { createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from 'react-router-dom';
import ErrorElement from './components/errors/ErrorElement';
import { ModalContextProvider } from './contexts/ModalContext';
import useRouter from './routers/useRouter';

function App() {
  const routes = useRouter();

  // https://github.com/remix-run/react-router/issues/10111 React.Fragment id collision
  // A <Route /> is currently used as wrapper for multiple routes within a condition to avoid this problem
  // <ErrorElement /> should be placed on the root level of the router to catch all errors
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        element={
          <ToastProvider>
            <ModalContextProvider>
              <BreakpointsContextProvider>
                <Outlet />
              </BreakpointsContextProvider>
            </ModalContextProvider>
          </ToastProvider>
        }
        errorElement={<ErrorElement />}
      >
        {routes}
      </Route>,
    ),
  );

  return <RouterProvider router={router} />;
}

export default App;
